<template>
    <div class="lookfor">
        <Head :index="'6'"></Head>
        <div class="chartTop">
            <!-- <div class="fl">
                山东省莒县阎庄镇孙家山沟村孙其昌后裔族谱|孙其昌 <span> 共563人</span>
            </div>
            <div class="fr"></div> -->
            <div>一键寻祖</div>
        </div>
        <div class="fl">
            本人姓名：
            <el-input type="text" v-model="name" autocomplete="off" placeholder="本人姓名"></el-input>
            父亲姓名：
            <el-input type="text" v-model="fathername" autocomplete="off"  placeholder="父亲姓名"></el-input>
            <el-button @click="searchClick()" type="primary" size="small" style="margin-left:82px">一键寻祖</el-button>
        </div>

        <div class="main fr" ref="chart">
            <!-- <div v-for="(item, index) in data" :key="index">
                {{ item.xm }}
            </div> -->
            <!-- <orgtree :data="data" v-if="data != {}" @NodeClick="NodeClick"></orgtree> -->
            <!-- <span>暂无</span> -->
            <!-- <div id="treeEcharts" style="width: 100%, height: 1000px" ref="treeEcharts"></div> -->
            <!-- <div v-for="(item, index) in data" :key="index">
                {{ item.xm }}
            </div> -->
            <div id="treeEcharts" style="margin:0 0 0 50px" ref="treeEcharts"></div>
        </div>
        <!-- <el-button @click="addClick()"
               type="text"
               size="small">添加</el-button> -->

        <!-- <el-table :data="tableData"
              style="width: 100%">
      <el-table-column prop="familyname"
                       label="家族姓氏"></el-table-column>
      <el-table-column prop="tangnum"
                       label="堂号"></el-table-column>
      <el-table-column prop="ancestorname"
                       label="始祖名讳"></el-table-column>
      <el-table-column prop="befrom"
                       label="发源地"></el-table-column>
      <el-table-column prop="familytree"
                       label="本谱世系"></el-table-column>
      <el-table-column prop="beforefamilytree"
                       label="上游谱中世系"></el-table-column>
      <el-table-column prop="intro"
                       label="家族简介"></el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       width="200">
        <template slot-scope="scope">
          <el-button @click="viewClick(scope.row)"
                     type="text"
                     size="small">查看</el-button>
          <el-button @click="editClick(scope.row)"
                     type="text"
                     size="small">编辑</el-button>
          <el-button @click="delClick(scope.row)"
                     type="text"
                     size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table> -->
    </div>
</template>
<script>
import Head from "@/components/header.vue";
import orgtree from "@/components/orgtree.vue";
import api from "@/request/api";
export default {
    data() {
        return {
            fathername: "",//孙汉池
            name: "",//孙惠
            name2: "",
            fathername2: "",
            data: [],
            echartsInit: null
        };
    },
    mounted() {},
    methods: {
        getList() {
            api.familyList().then((res) => {
                this.tableData = res.data;
            });
        },

        submitForm() {},
        searchClick() {
            // "fid=1&name=" + this.name + "&fathername=" + this.fathername
            api.memberFindancestor(
                this.$qs.stringify({
                    fid: localStorage.getItem("fid"),
                    name: this.name,
                    fathername: this.fathername
                })
            ).then((res) => {
                this.data = res.data;
                this.echartsFun();
            });
        },
        echartsFun() {
            var that = this;
            this.echartsInit = this.$echarts.init(this.$refs.treeEcharts);
            let treeData = this.data;
            this.echartsInit.setOption({
                title: {
                    show: false
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 1,
                            title: "保存为图片 ",
                            type: "png",
                            lang: ["点击保存"],
                            emphasis: {
                                iconStyle: {
                                    textPosition: "left"
                                }
                            }
                        }
                    }
                },

                calculable: false,
                zoom: 0.1,
                series: [
                    {
                        type: "tree",
                        data: treeData,
                        left: "2%",
                        right: "2%",
                        top: "5%",
                        bottom: "20%",
                        symbol: "emptyCircle",
                        orient: "vertical",
                        edgeShape: "polyline",
                        expandAndCollapse: true,
                        roam: true,
                        zoom: 1, //当前视角的缩放比例
                        initialTreeDepth: -1,
                        expandAndCollapse: false,
                        nodePadding: 10, //节点间距
                        layerPadding: 10, //层间距
                        lineStyle: {
                            //正常情况显示
                            color: "red",
                            width: 2
                        },
                        label: {
                            verticalAlign: "middle",
                            show: true,
                            padding: [15, 0],
                            width: 150, //尺寸大小
                            height: 60,
                            borderRadius: 10,
                            borderColor: "red",
                            color: "#000000",
                            align: "center",
                            formatter: function(params) {
                                params.data.label = {
                                    backgroundColor: "red"
                                };
                                params.data.label.backgroundColor = params.data.sex == 1 ? "#ffabd5" : "#96d5ff";
                                if (params.data.sgzt == 1) {
                                    params.data.label.borderWidth = 2;
                                    params.data.label.borderColor = "#000";
                                }
                                return (
                                    (params.data.ph != 0 ? "{a|" + that.ph(params.data.ph) + "} " : "") +
                                    "{b|" +
                                    params.data.xm +
                                    "}\n{c|" +
                                    (params.data.dc != "" && params.data.dc != null ? params.data.dc : "未知") +
                                    // (params.data.sr != "" && params.data.sr != null ? String(params.data.sr).split("-")[0] : "未知") +
                                    " - " +
                                    (params.data.jc != "" && params.data.jc != null ? params.data.jc : "至今") +
                                    // (params.data.qssj != "" && params.data.qssj != null ? String(params.data.qssj).split("-")[0] : "至今") +
                                    "}\n{x|" +
                                    that.toChies(params.data.shixu) +
                                    "世}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 10,
                                    borderWidth: 1,
                                    borderColor: "#000",
                                    borderRadius: 50,
                                    padding: 3,
                                    verticalAlign: "top",
                                    align: "center",
                                    lineHeight: 20
                                },
                                b: {
                                    fontSize: 16,
                                    margin: [10, 20]
                                },
                                c: {
                                    fontSize: 12,
                                    color: "#878787",
                                    lineHeight: 30
                                },
                                x: {
                                    fontSize: 12,
                                    color: "#fff"
                                }
                            }
                        },
                        leaves: {
                            label: {
                                verticalAlign: "middle",
                                align: "center"
                            }
                        },
                        animationDurationUpdate: 250
                    }
                ]
            });

            const getLevel = (arr) => {
                let maxLevel = 0;
                (function callBack(arr, level) {
                    ++level;
                    maxLevel = Math.max(level, maxLevel);
                    for (let i = 0; i < arr.length; i++) {
                        let item = arr[i];
                        if (item.children && item.children.length > 0) {
                            callBack(item.children, level);
                        } else {
                            delete item.children;
                        }
                    }
                })(arr, 0);
                return maxLevel;
            };
            function getMaxFloor(arr) {
                let maxLevel = [];
                (function callBack(arr, level) {
                    for (let i = 0; i < arr.length; i++) {
                        let item = arr[i];
                        if (item.children && item.children.length > 0) {
                            callBack(item.children, level);
                        } else {
                            maxLevel.push(item);
                        }
                    }
                })(arr, 0);
                return maxLevel;
            }

            // console.log(getMaxFloor(treeData), getLevel(treeData));
            const height = window.innerHeight;
            const width = window.innerWidth;
            const currentHeight = 170 * getLevel(treeData);
            // const currentWidth = 170 * getMaxFloor(treeData).length;
            let currentWidth = 200 * getMaxFloor(treeData).length;
            if (currentWidth > width - 400) {
                currentWidth = 150 * getMaxFloor(treeData).length;
            }
            const newHeight = Math.max(currentHeight, height - 115);
            // const newWidth = Math.max(currentWidth, width - 400);
            const tree_ele = document.getElementById("treeEcharts");
            tree_ele.style.height = newHeight + "px";
            tree_ele.style.width = currentWidth + "px";

            this.echartsInit.resize();
            // this.echartsInit.on("click", function(params, params1) {
            // that.NodeClick(params.data);
            // });
            this.echartsInit.on("treeroam", function(params) {
                // 控制台打印数据的名称
                if (params.originX || params.originY) {
                    let zoom = params.zoom;
                    let _option = that.echartsInit.getOption(); //获取最新的option配制
                    let series = _option.series[0];
                    series.label.padding[0] = series.label.padding[0] * zoom;
                    series.label.padding[1] = series.label.padding[1] * zoom;
                    series.label.height = series.label.height * zoom;
                    series.label.width = series.label.width * zoom;
                    series.label.borderRadius = series.label.borderRadius * zoom;
                    series.label.rich.a.fontSize = series.label.rich.a.fontSize * zoom;
                    series.label.rich.a.lineHeight = series.label.rich.a.lineHeight * zoom;
                    series.label.rich.a.padding = series.label.rich.a.padding * zoom;
                    series.label.rich.b.fontSize = series.label.rich.b.fontSize * zoom;
                    series.label.rich.b.margin[0] = series.label.rich.b.margin[0] * zoom;
                    series.label.rich.b.margin[1] = series.label.rich.b.margin[1] * zoom;
                    series.label.rich.c.fontSize = series.label.rich.c.fontSize * zoom;
                    series.label.rich.c.lineHeight = series.label.rich.c.lineHeight * zoom;
                    series.label.rich.x.fontSize = series.label.rich.x.fontSize * zoom;
                    that.echartsInit.setOption(_option); //更新修改后的option配制
                }
            });
        }
    },
    computed: {
        ph() {
            return function(val) {
                let ph = "";
                for (let i = 0; i < this.$store.state.phData.length; i++) {
                    if (val == this.$store.state.phData[i].val) {
                        ph = this.$store.state.phData[i].key;
                    }
                }
                return ph;
            };
        },
        toChies() {
            return function(val) {
                return this.$utils.toChies(val);
            };
        }
    },
    components: {
        Head,
        orgtree
    }
};
</script>

<style lang="less" scoped>
.lookfor {
    overflow: hidden;
    height: 100%;
   
    .chartTop {
        // height: 55px;
        // line-height: 55px;
        font-size: 15px;
        padding:20px 0 10px 15px;
        h1 {
            width: 350px;
            font-size: 20px;
        }
        .fr {
            .el-input {
                display: inline-block;
                width: 100px;
            }
            button {
                margin: 0 10px;
            }
        }
    }

    > .fl {
        padding: 10px 20px;
        width: 210px;
        box-sizing: border-box;
        font-size: 14px;
        /deep/.el-input {
            display: inline-block;
            width: 90px;
            margin-bottom: 20px;
            right: 0;
        }
    }
    > .fr {
        width: calc(100% - 240px);
    }

    .main {
        text-align: center;
        overflow: auto;
        height: calc(100% - 115px);
        > div {
            width: 100%;
            height: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/lookfor.vue